import { useHistory } from '@framework/ui';
import { useCallback } from 'react';

/**
 * Imposta un flag di logout nello stato della history.
 * In questo modo in caso di login immediatamente successivo
 * (senza ricaricare) il redirect sarà verso la pagina "home"
 * e non verso l'ultima pagina visitata.
 */
export function useSetLogoutHistoryState() {
  const history = useHistory();

  const setLogoutState = useCallback(() => {
    history.replace(history.location, {
      ...(history.location.state ?? {}),
      hasLoggedOut: true,
    });
  }, [history]);

  return setLogoutState;
}
